<template>
  <d-navbar-nav class="border-left flex-row">
    <li class="nav-item border-right dropdown notifications">
      <a class="nav-link nav-link-icon text-center" v-d-toggle.notifications>
        <div class="nav-link-icon__wrapper">
          <i class="material-icons">&#xE7F4;</i>
          <d-badge pill theme="danger">{{ countUnread }}</d-badge>
        </div>
      </a>
    </li>
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle text-nowrap px-3"
        v-d-toggle.user-actions
        @click="checkAdmin"
      >
        <img
          class="user-avatar rounded-circle mr-2"
          :src="user.settings.image.url"
          :alt="user.name"
          v-if="user.settings.image.name"
        />
        <img
          class="user-avatar rounded-circle mr-2"
          src="@/assets/images/avatars/enhanced-buzz.jpeg"
          :alt="user.name"
          v-else
        />
        <span class="d-none d-md-inline-block">{{ user.name }}</span>
      </a>
      <d-collapse
        id="user-actions"
        ref="userActions"
        class="dropdown-menu dropdown-menu-small"
      >
        <a
          href="#"
          tag="a"
          routertag="a"
          class="dropdown-item"
          @click="closeUserActions()"
        >
          <d-link :to="{ name: 'admin-perfil' }">
            <i class="material-icons">&#xE7FD;</i>
            {{ $t('navbar.menu.profile') }}
          </d-link>
        </a>
        <a
          href="#"
          tag="a"
          routertag="a"
          class="dropdown-item"
          @click="closeUserActions()"
          v-if="isAdmin"
        >
          <router-link :to="{ name: 'admin-settings' }">
            <i class="material-icons">settings</i>
            {{ $t('navbar.menu.settings') }}
          </router-link>
        </a>
        <d-dropdown-divider />
        <d-dropdown-item class="text-danger">
          <div @click.prevent="logout()">
            <i class="material-icons text-danger">&#xE879;</i>
            {{ $t('navbar.menu.logout') }}
          </div>
        </d-dropdown-item>
      </d-collapse>
    </li>
  </d-navbar-nav>
</template>

<script>
import { mapActions } from 'vuex';
import { MODEL } from '_modules/user/components/UserModel';

export default {
  name: 'navbar-nav',
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    user() {
      const { user } = this.$store.state.user;
      if (user) {
        return user;
      }
      return { ...MODEL };
    },
  },
  data() {
    return {
      countUnread: null,
    };
  },
  methods: {
    ...mapActions({
      activeAlert: 'activeAlert',
      storeLogout: 'logout',
      checkAdmin: 'checkAdmin',
    }),
    logout() {
      this.storeLogout().then(() => {
        this.$router.push('/public/login');
      });
    },
    closeUserActions() {
      this.$refs.userActions.show = false;
    },
    closeNotifications() {
      this.$refs.notifications.show = false;
    },
  },
  mounted() {},
};
</script>

<style>
.nav-link:hover {
  cursor: pointer;
}
</style>
